import React, { useMemo, useState, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useTheme } from "react-jss"

import { Button } from "@portal/kit/pkg/components"
import subscriptionStyle from "./subscription-card-style"
import { dateToLocaleString } from 'helpers/date'
import UnsubscribePopin from "../unsubscribe-popin"

export default function SubscriptionCard({ subscription, unsubscribeSubscription }) {
  const [opened, setOpened] = useState(false)
  const [popinError, setPopinError] = useState(null)

  const theme = useTheme()
  const { t, i18n } = useTranslation()

  const { id, starts_at, ends_at, offer } = subscription

  const start_date = useMemo(() => {
    return dateToLocaleString({ date: starts_at, language: i18n.language })
  }, [i18n.language, starts_at])

  const endDate = useMemo(() => {
    if (!ends_at) return

    return dateToLocaleString({ date: ends_at, language: i18n.language })
  }, [i18n.language, ends_at])

  const classes = subscriptionStyle(theme)

  const unsubscribe = useCallback(async (endsAt) => {
    const { success, error } = await unsubscribeSubscription(id, endsAt)
    if (success) {
      setOpened(false)
    } else {
      setPopinError(`subscription.resiliation.errors.${error.code}`)
    }
  }, [unsubscribeSubscription, id])

  return (
    <div className={classes.container}>
      <div className={classes.offer}>
        <p>
          <strong>{offer.locales[i18n.language].name}</strong>
        </p>
        <ul>
          <li> {t('subscription.start_date', { date: start_date, interpolation: { escapeValue: false } })}</li>
          {endDate && <li> {t('subscription.end_date', { date: endDate, interpolation: { escapeValue: false } })}</li>}
        </ul>
      </div>
      <div>
        <Button disabled={endDate} onClick={endDate ? null : () => setOpened(true) } classType="error">{t('subscription.buttons.unsubscribe')}</Button>
      </div>
      <UnsubscribePopin opened={opened} cancel={() => setOpened(false)} unsubscribe={unsubscribe} popinError={popinError} />
    </div>
  )
}
